import { Menu, MenuItem } from "@mui/material";
import { DEAL_INDEX, indexNames } from "constants/reports";
import React from "react";

interface Props {
  anchorEl: HTMLElement | null;
  selectedIndex: {
    name: string,
    index: string,
  } | null;
  calculatedFields: string[];
  onClose: () => void;
  onSelectIndex: (value: Props["selectedIndex"]) => void;
}

const SPECIFIC_DEAL_INDEX = "Use deal specific index";

export const TableIndexNameMenu: React.FC<Props> = ({ anchorEl, selectedIndex, calculatedFields, onClose, onSelectIndex }) => {
  return (
    <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={onClose}>
      <MenuItem onClick={() => onSelectIndex(null)}>None</MenuItem>
      <MenuItem
        selected={!selectedIndex && calculatedFields?.includes("PME")}
        onClick={() => onSelectIndex({ name: SPECIFIC_DEAL_INDEX, index: DEAL_INDEX })}
      >
        {SPECIFIC_DEAL_INDEX}
      </MenuItem>
      {Object.entries(indexNames).map(([index, name]) => (
        <MenuItem key={index} selected={index === selectedIndex?.index} onClick={() => onSelectIndex({ name, index })}>
          {name}
        </MenuItem>
      ))}
    </Menu>
  );
};